var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdown = function SvgDropdown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.43 12.78a.61.61 0 0 1-.86 0L2.45 5.67a.62.62 0 0 1 0-.87L4 3.22a.61.61 0 0 1 .86 0L10 8.31l5.1-5.1a.61.61 0 0 1 .86 0l1.59 1.59a.62.62 0 0 1 0 .87Z",
    fill: "#8ed6c9"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiI+PGc+PHBhdGggZD0iTTEwLjQzIDEyLjc4YS42MS42MSAwIDAgMS0uODYgMEwyLjQ1IDUuNjdhLjYyLjYyIDAgMCAxIDAtLjg3TDQgMy4yMmEuNjEuNjEgMCAwIDEgLjg2IDBMMTAgOC4zMWw1LjEtNS4xYS42MS42MSAwIDAgMSAuODYgMGwxLjU5IDEuNTlhLjYyLjYyIDAgMCAxIDAgLjg3WiIgZmlsbD0iIzhlZDZjOSIvPjwvZz48L3N2Zz4KCg==";